import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { BetaFlag } from 'src/components/BetaFlag';
import BrandIcon from 'src/components/BrandIcon';
import { DataInfo } from 'src/components/DataInfo';
import TypeIcon from 'src/components/TypeIcon';
import { Box } from '../Box';
import { Tooltip } from '../Tooltip';
import { Typography } from '../Typography';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

interface ProfileCardHeaderProps {
  icon: IconProp | string;
  isCRM?: boolean;
  title: string;
  hasSelectedSavedSearch?: boolean;
  currentSavedSearch?: string;
  subHeader?: string;
  isBeta?: boolean;
  infoTooltip?: boolean;
  tooltipView?: string;
}

const ProfileCardHeader = ({
  icon,
  isCRM = false,
  title,
  hasSelectedSavedSearch,
  currentSavedSearch,
  subHeader,
  isBeta = false,
  infoTooltip = false,
  tooltipView,
}: ProfileCardHeaderProps) => {
  return (
    <Box className="flex flex-col gap-1 pb-4" aria-label={title}>
      <Box className="flex items-center gap-1.5 w-full">
        {isCRM && typeof icon === 'string' ? (
          <BrandIcon
            brand={icon}
            width={icon === 'third_party' ? '1.2rem' : '1.5rem'}
            height={icon === 'third_party' ? '1.2rem' : '1.4rem'}
            neutral={true}
          />
        ) : typeof icon === 'string' ? (
          <TypeIcon type={icon} color="#525252" />
        ) : (
          <Icon icon={icon as IconProp} className="text-neutral-600" />
        )}
        <Box className="flex items-center flex-row gap-1 min-w-0">
          <Typography className="text-primary font-bold text-lg whitespace-nowrap">
            {title}
            {infoTooltip && (
              <Tooltip
                position="top"
                content={
                  <Box className="flex flex-col max-w-80 justify-center p-1">
                    <DataInfo view={tooltipView} />
                  </Box>
                }
              >
                <Icon
                  icon={faInfoCircle}
                  height={16}
                  width={16}
                  style={{
                    color: '#737373',
                    marginLeft: '.5rem',
                  }}
                />
              </Tooltip>
            )}
          </Typography>
          {currentSavedSearch && (
            <Typography
              className={`${
                hasSelectedSavedSearch ? 'text-teal-700' : ''
              } font-bold text-lg whitespace-nowrap truncate`}
              color={hasSelectedSavedSearch ? 'inherit' : 'primary'}
            >
              {currentSavedSearch}
            </Typography>
          )}
        </Box>
        {isBeta && <BetaFlag />}
      </Box>
      {subHeader && (
        <Typography variant="body2" className="text-tertiary">
          {subHeader}
        </Typography>
      )}
    </Box>
  );
};

export default ProfileCardHeader;
